/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_WorkspaceResponse_ } from '../models/PaginatedResponse_WorkspaceResponse_';
import type { WorkspaceCreateRequest } from '../models/WorkspaceCreateRequest';
import type { WorkspaceResponse } from '../models/WorkspaceResponse';
import type { WorkspaceUpdateRequest } from '../models/WorkspaceUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkspaceService {
    /**
     * List Joined Workspaces
     * 사용자가 참여한 워크스페이스 목록 조회 (페이지네이션, 역할 기반 접근 제어)
     *
     * 인증된 사용자가 접근 가능한 워크스페이스 목록을 역할에 따라 다르게 반환합니다.
     *
     * 접근 규칙:
     * - admin/owner: 해당 기관의 삭제되지 않은 모든 워크스페이스
     * - normal: OrgMemberWorkspace를 통해 명시적으로 할당된 워크스페이스만
     *
     * Args:
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     *
     * Returns:
     * PaginatedResponse[WorkspaceResponse]: 역할 기반으로 필터링된 워크스페이스 목록
     * @returns PaginatedResponse_WorkspaceResponse_ OK
     * @throws ApiError
     */
    public static appsWorkspaceViewsListJoinedWorkspaces({
        page = 1,
        perPage = 100,
    }: {
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_WorkspaceResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workspace/joined',
            query: {
                'page': page,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Workspace
     *     워크스페이스 생성
     *
     * 새로운 워크스페이스를 생성합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns WorkspaceResponse Created
     * @throws ApiError
     */
    public static appsWorkspaceViewsCreateWorkspace({
        requestBody,
    }: {
        requestBody: WorkspaceCreateRequest,
    }): CancelablePromise<WorkspaceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/workspace',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Workspaces
     * 워크스페이스 목록 조회 및 검색
     *
     * 워크스페이스를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * org_id: 기관 ID로 필터링 (필수)
     * include_unavailable: 비활성 워크스페이스 포함 여부 (기본값: False)
     * - True인 경우 owner 또는 admin 권한 필요
     * q: 검색 키워드 (선택사항) - 워크스페이스명 검색
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse_WorkspaceResponse_ OK
     * @throws ApiError
     */
    public static appsWorkspaceViewsListWorkspaces({
        orgId,
        includeUnavailable = false,
        q,
        page = 1,
        perPage = 100,
    }: {
        orgId: string,
        includeUnavailable?: boolean,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_WorkspaceResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workspace',
            query: {
                'org_id': orgId,
                'include_unavailable': includeUnavailable,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Workspace
     * 워크스페이스 조회
     *
     * ID로 특정 워크스페이스를 조회합니다.
     * @returns WorkspaceResponse OK
     * @throws ApiError
     */
    public static appsWorkspaceViewsGetWorkspace({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<WorkspaceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workspace/{workspace_id}',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Workspace
     *     워크스페이스 정보 수정
     *
     * 특정 워크스페이스의 정보를 수정합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns WorkspaceResponse OK
     * @throws ApiError
     */
    public static appsWorkspaceViewsUpdateWorkspace({
        workspaceId,
        requestBody,
    }: {
        workspaceId: string,
        requestBody: WorkspaceUpdateRequest,
    }): CancelablePromise<WorkspaceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/workspace/{workspace_id}',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Workspace
     *     워크스페이스 삭제
     *
     * 특정 워크스페이스를 삭제합니다. (소프트 삭제)
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsWorkspaceViewsDeleteWorkspace({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/workspace/{workspace_id}',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
